import { QUERY_PARAM_KEYS } from "constants/query";

import { useState, useRef, useEffect } from "react";

import { DEFAULT_PAGE_INDEX } from "components/constants";
import Filter from "components/Filter";
import History from "components/History";
import useDebounce from "hooks/useDebounce";
import useQuery from "hooks/useQuery";
import useQueryUpdater from "hooks/useQueryUpdater";
import useSlashFocus from "hooks/useSlashFocus";
import { Search } from "neetoicons";
import { Input } from "neetoui";
import { isEmpty } from "ramda";
import { useTranslation } from "react-i18next";

import Content from "./Content";

const MovieList = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const { SEARCH_ITEM, YEAR, TYPE, PAGE } = QUERY_PARAM_KEYS;

  const searchItem = query.get(SEARCH_ITEM) || "";
  const year = query.get(YEAR) || "";
  const typeParam = query.get(TYPE) || "";
  const pageNumber = Number(query.get(PAGE)) || DEFAULT_PAGE_INDEX;

  const [searchValue, setSearchValue] = useState(searchItem);

  const updateQueryParams = useQueryUpdater();
  const inputRef = useRef(null);
  useSlashFocus(inputRef);

  const debouncedSearchValue = useDebounce(searchValue, 1000);
  const debouncedYear = useDebounce(year, 500);

  useEffect(() => {
    if (isEmpty(debouncedSearchValue)) {
      updateQueryParams({});
    } else {
      updateQueryParams({
        searchItem: debouncedSearchValue,
        page: DEFAULT_PAGE_INDEX,
      });
    }
  }, [debouncedSearchValue]);

  return (
    <div className="flex min-h-screen flex-row pt-16">
      <div className="relative w-2/3 flex-auto space-y-6 overflow-y-auto bg-gray-100">
        <div className="fixed top-16 z-10 flex w-2/3 flex-auto flex-row items-center space-x-2 bg-gray-100 p-4">
          <Input
            className="bg-white-100"
            placeholder={t("placeHolder.search")}
            prefix={<Search className="bg-transparent" />}
            ref={inputRef}
            type="search"
            value={searchValue}
            onChange={({ target: { value } }) => setSearchValue(value)}
          />
          <Filter />
        </div>
        <Content
          pageNumber={pageNumber}
          movieListParams={{
            searchValue: debouncedSearchValue,
            page: pageNumber,
            type: typeParam,
            year: debouncedYear,
          }}
        />
      </div>
      <div className="w-1/3 justify-center overflow-y-auto border-l border-gray-300 bg-white">
        <History />
      </div>
    </div>
  );
};

export default MovieList;
